import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "dialog-detail mt-s3" }
const _hoisted_3 = { class: "mb-s2" }
const _hoisted_4 = { class: "text-sm text-muted mb-s1" }
const _hoisted_5 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_6 = { class: "mb-s2" }
const _hoisted_7 = { class: "text-sm text-muted mb-s1" }
const _hoisted_8 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_9 = { class: "text-sm text-muted" }
const _hoisted_10 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_11 = {
  key: 0,
  class: "flex justify-content-end"
}

import { useUtils } from '@/composables/utils/useUtils';
import { HIGH_RATES_LEARN_MORE } from '@/constants/EXTERNAL_LINKS';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HighRatesDetails',
  props: {
    tvlLevels: null,
    aprWeights: null,
    type: null,
    noLink: { type: Boolean }
  },
  setup(__props: any) {



const { openExternalLink } = useUtils();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('learnMoreDialog.description', { type: __props.type })), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('learnMoreDialog.epoch1.caption')) + ":", 1),
        (!__props.tvlLevels.length > 0 || !__props.aprWeights.length > 0)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "w-9"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('learnMoreDialog.epoch1.content', { tvl: `$${__props.tvlLevels[1]}`, percent: __props.aprWeights[0] })), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('learnMoreDialog.epoch2.caption')) + ":", 1),
        (!__props.tvlLevels.length > 0 || !__props.aprWeights.length > 0)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "w-9"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('learnMoreDialog.epoch2.content', {
              tvl: `$${__props.tvlLevels[1]}-$${__props.tvlLevels[2]}`,
              percent: __props.aprWeights[0] + __props.aprWeights[1],
            })), 1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('learnMoreDialog.epoch3.caption')) + ":", 1),
        (!__props.tvlLevels.length > 0 || !__props.aprWeights.length > 0)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "w-9"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('learnMoreDialog.epoch3.content', {
              tvl: `$${__props.tvlLevels[2]}`,
              percent: __props.aprWeights[0] + __props.aprWeights[1] + __props.aprWeights[2],
            })), 1))
      ])
    ]),
    (!__props.noLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_Button, {
            class: "text-sm button-text mt-s2 text-primary",
            label: _unref(t)('readDocs'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openExternalLink)(_unref(HIGH_RATES_LEARN_MORE))))
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})